import React from "react";
import Canvas from "./components/Canvas";
import Layout from "./layout";

const App = () => {
  return (
    <Layout>
      <Canvas></Canvas>
    </Layout>
  );
};

export default App;
